<script setup>
import { ref, onMounted, watch, computed } from 'vue'
import { useAssessmentsStore, useAuthStore, useAppStore } from '../stores';
import { useRoute } from 'vue-router';
import AppLink from '../components/layouts/AppLink.vue';
import AppCard from '../components/layouts/AppCard.vue';
import AppPreviewCard from '../components/layouts/AppPreviewCard.vue';
import { randomColorString } from '../helpers/utils'
import { useRouter } from 'vue-router'
import { shortDate } from '../helpers/utils'
import iconArrowRight from '~/assets/icon_arrow_right.svg'

const router = useRouter()


const assessmentsStore = useAssessmentsStore();
const authStore = useAuthStore();
const route = useRoute()
const readinessAreas = ref([])
const title = ref('')
// const readinessAssessments = ref([])
const childId = ref(null)
// TODO: this is a hack to get the current report card. We should be able to get it from the store
const currentReportCard = ref({})

watch(route, async (to, prev) => {
  if (to.path.includes('readiness/report-card') && to.params.id) {
    fetchReadinessReportCard(to.params.id)
  }
})

onMounted(async () => {
  await fetchReadinessReportCard(route.params.id)
})

const fetchReadinessReportCard = async (reportCardId) => {
  let parsedId = parseInt(reportCardId)
  if (!assessmentsStore.getReadinessReportCardById(parsedId) || !assessmentsStore.getReadinessReportCardById(parsedId).readiness_assessment_ids) {
    await assessmentsStore.fetchReadinessReportCarById(parsedId)
  }
  let current = assessmentsStore.getReadinessReportCardById(parsedId)
  currentReportCard.value = current
  readinessAreas.value = current.readiness_map
  
  // TODO: the title should be coming from the API but is coming back as 'Readiness Guide'
  title.value = `${current.child.first_name}'s ${current.short_title} Readiness Report Card`

  childId.value = current.child.id

  if (authStore.currentChild && authStore.currentChild.current_readiness_report_card) {
    authStore.currentChild.current_readiness_report_card = current
  }
}

const createAssessment = (readinessAreaId) => {
  assessmentsStore.createReadinessAssessment(childId.value, route.params.id, readinessAreaId)
}

const readinessAssessments = computed(() => {
  if (assessmentsStore.getReadinessReportCardById(route.params.id)) {
    return assessmentsStore.getReportCardAssessments(parseInt(route.params.id))
  } else {
    return []
  }
})
</script>
<template>
  <div class="mx-2">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 justify-center items-center content-start">
      <AppCard :header="title">
        <!-- :body="`${currentReportCard.days_remaining} ${currentReportCard.past_deadline ? 'past deadline' : 'days remaining'}`" -->
        <!-- <div class="text-sm"> {{ currentReportCard.days_remaining }} days remaining </div> -->
        <div class="gap-1 grid grid-cols-1 md:grid-cols-1 text-gray-700">
          <dl v-for="readinessArea, idx in readinessAreas" :key="`readiness-area-${readinessArea.readiness_area.id}`">
            <dt class="text-sm text-gray-500">{{ readinessArea.readiness_area.title.replace('Development',
              'Milestones') }}</dt>
            <dd class="flex items-center">
              <div class="w-full bg-gray-200 rounded h-2.5 mr-2">
                <div
                  :class="`${idx % 3 == 0 ? 'bg-accent' : idx % 2 == 0 ? idx % 4 == 0 ? 'bg-tertiary' : 'bg-secondary' : 'bg-primary'} h-2.5 rounded`"
                  :style="{ width: `${(readinessArea.milestones.achieved.length / readinessArea.milestones.total) * 100}%` }">
                </div>
              </div>
              <span class="text-sm text-gray-500 ">{{ readinessArea.milestones.achieved.length }}/{{
                readinessArea.milestones.total }}</span>
              <!-- <img class="w-5 h-5 basis-2/12 justify-self-end cursor-pointer" aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" :src="iconArrowRight" /> -->
              <svg class="ml-2 w-8  h-8 text-secondary" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                fill="currentColor" viewBox="0 0 20 20" @click="createAssessment(readinessArea.readiness_area.id)">
                <path
                  d="M9.546.5a9.5 9.5 0 1 0 9.5 9.5 9.51 9.51 0 0 0-9.5-9.5ZM13.788 11h-3.242v3.242a1 1 0 1 1-2 0V11H5.304a1 1 0 0 1 0-2h3.242V5.758a1 1 0 0 1 2 0V9h3.242a1 1 0 1 1 0 2Z" />
              </svg>
              <span class="sr-only">New Readiness Report</span>
            </dd>
          </dl>
        </div>
      </AppCard>
      <AppCard header="Success Contracts"  v-if="useAppStore.showContracts" >
        <!-- <div class="max-h-36 overflow-y-auto">
          <div v-for="area in readinessAreas" :key="`readiness-area-${area.readiness_area.id}`">
            <div v-for="milestone in area.milestones.pending" :key="`readiness-milestone-${milestone.id}`"
              class="flex flex-col mx-1 mb-2 text-sm">
              <div class="text-black font-bold" v-if="area.milestones.pending.length">
                {{ area.readiness_area.title.replace('Development','') }}
              </div>
              <div class="">{{ milestone.title }}</div>
            </div>
          </div>
        </div> -->
      </AppCard>
      <!-- <AppCard header="Missing Milestones">
        <div class="max-h-36 overflow-y-auto">
          <div v-for="area in readinessAreas" :key="`readiness-area-${area.readiness_area.id}`">
            <div v-for="milestone in area.milestones.pending" :key="`readiness-milestone-${milestone.id}`"
              class="flex flex-col mx-1 mb-2 text-sm">
              <div class="text-black font-bold" v-if="area.milestones.pending.length">
                {{ area.readiness_area.title.replace('Development','') }}
              </div>
              <div class="">{{ milestone.title }}</div>
            </div>
          </div>
        </div>
      </AppCard> -->
      <AppCard :header="`Assessment History`">
        <div class="max-h-48 overflow-y-auto">
          <div v-for="(assessment, idx) in readinessAssessments" :key="`readiness-assesment-list-${assessment.id}`">
            <AppPreviewCard
              @clicked="router.push(`/readiness/assessments/${assessment.id}${assessment.completed ? '/show' : ''}`)">
              <!-- grid grid-rows-1 grid-flow-row -->
              <div class="flex flex-row w-full justify-start content-center items-center text-xs ">
                <div :class="`text-gray-500 basis-2/12`"> {{ shortDate(assessment.updated_at) }}</div>
                <div class="mx-1.5 text-gray-500 justify-self-start basis-8/12">{{
                  assessment.readiness_area.attributes.title.replace('Development', '') }}</div>
                <div class="basis-/12 justify-self-end">
                  <svg class="w-6 h-6" :class="assessment.completed ? 'text-green-500' : 'text-grey-800'"
                    aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="m7 10 2 2 4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                  </svg>
                </div>
                <div class="text-gray-500 basis-2/12 pl-1">{{
                  assessment.assessment_milestones.filter(milestone =>
                    milestone.achieved).length }}/{{ assessment.assessment_milestones.length }}</div>
              </div>
            </AppPreviewCard>
          </div>
        </div>
      </AppCard>
      <!-- <div class="fixed right-4 bottom-20 group ">
        <button type="button" @click="createAssessment"
          class="flex items-center justify-center text-white bg-teal-400 rounded-full w-14 h-14 hover:bg-teal-500 focus:ring-4 focus:ring-blue-300 focus:outline-none">
          <svg class="w-5 h-5 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 1v16M1 9h16" />
          </svg>
          <span class="sr-only">New Readiness Assessment</span>
        </button>
      </div> -->
    </div>
  </div>
</template>